(ns ui.components.image-uploader.view
  (:require [common.localization :as loc]
            [frontend.utils :as fu]
            [clojure.string :as string]))

;;TODO rewrite this to tailwind

(defn photo [{:keys [show-title? picture-url css-class key label on-remove! view-only?]}]
  (let [missing-kw (keyword (str "missing-" (name key)))
        picture-url (fu/only-https-or-relative-img picture-url)]
    [:div
     (when show-title?
       [:label
        {:class "mb-1 text-base-light-text font-semibold text-sm"}
        label])
     [:div
      {:class "p-3 flex w-64 h-24 relative bg-base-gloomy rounded "}
      (if-not (string/blank? picture-url)
        [:div
         {:class-name (str " w-full h-full bg-contain bg-center bg-no-repeat  " "" css-class)
          :style      {:background-image (str "url(" (fu/sanitize-img-url picture-url) ")")}}]
        [:div
         [:p (loc/tr missing-kw)]])
      (when (and (not view-only?) on-remove!)
        [:span
         {:class "position-absolute right-2 top-2 text-base-gloomy-text cursor-pointer"}
         [:i.fal.fa-times-circle
          {:on-click on-remove!}]])]]))

(defn image-view []
  (let [input-id (str "input-id-" (gensym))]
    (fn [{:keys [edit? show-title? id value edit-value key label on-change on-remove! img-size css-class view-only?]}]
      (if edit?
        [:form
         {:action     "/api/attachment"
          :class-name (str "flex flex-col gap-1")}
         (when show-title?
           [:label 
            {:class "mb-0 text-base-light-text font-semibold text-sm"}
            label])
         [:div
          {:class "h-36 p-3 flex flex-col  justify-center items-center border border-dashed border-input-light-border-paler hover:border-base-light-border rounded relative"}
          [:div
           {:class "p-4 flex flex-col gap-1 text-center"}
           [:i.fas.fa-cloud-upload 
            {:class "text-2xl text-input-light-text-paler"}]
           [:span
            {:class "block"}
            (loc/tr :dropzone-instructions-pre-link)]
           [:span 
             {:class "pb-1 block uppercase text-xs text-base-light-text-paler"}
            (loc/tr :or-with-spaces)]
           [:span
            {:class "px-2 pt-2 pb-2.5 flex-inline items-center text-base-light-text font-semibold text-capitalize leading-3 bg-primary-regular hover:primary-gloomy rounded-full"}
            (loc/tr :dropzone-instructions-link)]
          ;;  [:span
          ;;   (loc/tr :dropzone-instructions-post-link)]

           [:span.dropzone-info-text
            (when img-size
              (loc/tr :dropzone-recommended-image-size [img-size]))]]
          [:input
           {:type      "file"
            :class "w-full h-full absolute l-0 t-0 opacity-0 cursor-pointer"
            :on-focus  (fn [e]
                         (.preventDefault e)
                         (.setTimeout js/window (fn []
                                                  (.blur (.getElementById js/document input-id))) 300)
                         false)
            :id        input-id
            :on-change on-change}]]] 
          [photo {:show-title? show-title?
                  :css-class   css-class
                  :picture-url value
                  :on-remove!  on-remove!
                  :key         key
                  :label       label
                  :view-only? view-only?}]))))
